import i18n from "i18next";
import translationEn from "./locales/en/translation.json";
import translationEs from "./locales/es/translation.json";

i18n.init({
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: { translations: translationEn },
    es: { translations: translationEs },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

export default i18n;